






























import { Component, Vue } from 'vue-property-decorator';
import JdsPanelGridLayout from '@/design-system/patterns/Panel/JdsPanelGridLayout.vue';
import JdsPanel from '@/design-system/patterns/Panel/JdsPanel.vue';
import JdsPanelHeading from '@/design-system/patterns/Panel/JdsPanelHeading.vue';
import JdsPanelTab from '@/design-system/patterns/Panel/JdsPanelTab.vue';
import JdsPanelTabBar from '@/design-system/patterns/Panel/JdsPanelTabBar.vue';
import JdsJobTileListLayout from '@/design-system/constructs/JobTile/JdsJobTileListLayout.vue';
import JobTile from '@/content/8-constructs/JobTile.vue';
import JdsJobTile from '@/design-system/constructs/JobTile/JdsJobTile.vue';
import JdsGlyph from '@/design-system/icons/JdsGlyph.vue';
import { Job } from '@/design-system/constructs/JobTile/JobTileViewModel';

@Component({
    components: {
        JdsGlyph,
        JdsJobTile,
        JobTile,
        JdsJobTileListLayout,
        JdsPanelTabBar,
        JdsPanelTab,
        JdsPanelHeading,
        JdsPanel,
        JdsPanelGridLayout,
    },
})
export default class JdpDashboard extends Vue {
    showDh = false;

    get jobsFromStaging(): Job[] {
        return [
            {
                id: 238337,
                location: 'Blaviken',
                is_hidden: false,
                status: 'open',
                title: 'Butcher',
                active_from: '2022-04-29T22:00:00+00:00',
                active_to: null,
                first_hired_at: '2022-09-22T07:43:48+00:00',
                archived_at: null,
                campaigns: [
                    {
                        id: '1d6867f0-961b-4fce-aed1-11801d99eb22',
                        job_id: 238337,
                        status: 'ended',
                        starts_at: '2022-06-14T00:00:00+00:00',
                        ends_at: '2022-06-27T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '42725167-6ba3-4238-9efb-dbea0675cc13',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-10-14T00:00:00+00:00',
                        ends_at: '2022-10-28T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '6dbd862b-1fbe-4fa2-85db-7996a04f608e',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-08-12T00:00:00+00:00',
                        ends_at: '2022-08-26T00:00:00+00:00',
                        title: 'Butcher',
                        intro: 'Are you interested in working for ? Test if you could be our new Butcher!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://forms.staging.jobilla.com/7cf3d8e6-5f47-41c6-b564-5c8f19cc7a63',
                        is_active: false,
                    },
                    {
                        id: '71a484d7-8bc3-4e8f-954e-86ffc71adc78',
                        job_id: 238337,
                        status: 'pushed',
                        starts_at: '2022-08-29T00:00:00+00:00',
                        ends_at: '2022-09-12T00:00:00+00:00',
                        title: 'Frontend developer',
                        intro: 'Hey developer! Would you be interested to work for Jobilla? We got:\n\nHigh quality work equipment\n\nPossibility to focus to your work\n\nPossibility to full remote work\n\nExperienced and friendly team\n\nPossibility to constantly develop yourself on work time\n\nInterested? Answer few questions and test if Jobilla would fit for you!',
                        description: 'Check your results in a few minutes!',
                        url: 'https://questionnaires.jobilla.com/40c4e370-cc3e-11eb-af8f-97630d7cfffb',
                        is_active: false,
                    },
                ],
                pipeline: {
                    entry: 2,
                    other: 11,
                    hire: 3,
                    rejection: 2,
                },
                number_of_unread_mails: 0,
                subscribers: [
                    {
                        id: 24455,
                        name: 'Vladimir Andronov 20220630',
                        email: 'vladimir.andronov+20220630@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: null,
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 6922,
                        name: 'Ilan Moatty',
                        email: 'ilan.moatty@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: null,
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 2376,
                        name: 'Antti Rössi',
                        email: 'antti.rossi2@outlook.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: 'yMKOP2MBXSIBew77GNzIhUE5.jpg',
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                    {
                        id: 6843,
                        name: 'Anton',
                        email: 'anton.peraviortau@jobilla.com',
                        language: null,
                        cityId: null,
                        source: null,
                        profileImage: 'https://storage.googleapis.com/jobilla-uploads-staging/user/attachment/danSzyt8TcLgWb9IKon7EKOa.jpeg',
                        avatar: 'https://images.staging.jobilla.com/user/attachment/danSzyt8TcLgWb9IKon7EKOa.jpeg?fm=webp&width=undefined',
                        createdAt: null,
                        lastSeen: null,
                        role: null,
                        setupCompleted: true,
                        setupCompletedAt: null,
                        isInvitationExpired: false,
                        hubspotId: null,
                        unit: null,
                    },
                ],
                is_starred: false,
            },
        ];
    }
}
